import * as Yup from 'yup';

export const subAgencyValidationSchema = Yup.object().shape({
    agency: Yup.object().shape({
        name: Yup.string()
            .required('Agency name is required')
            .min(2, 'Agency name must be at least 2 characters'),
        email: Yup.string()
            .email('Invalid email format')
            .required('Agency email is required'),
        phone: Yup.string()
            .required('Agency phone is required')
            .matches(/^[0-9+\-\s()]*$/, 'Invalid phone number format'),
        markup: Yup.number()
            .required('Markup is required')
            .min(0, 'Markup cannot be negative'),
        image: Yup.mixed()
            .nullable()
            .test('fileSize', 'File too large', (value) => {
                if (!value) return true;
                return value.size <= 5000000; // 5MB
            })
            .test('fileType', 'Unsupported file type', (value) => {
                if (!value) return true;
                return ['image/jpeg', 'image/png', 'image/jpg'].includes(value.type);
            }),
        description: Yup.string().nullable(),
        address: Yup.object().shape({
            address: Yup.string().required('Billing address is required'),
            country_id: Yup.string().required('Billing country is required'),
            state_id: Yup.string().nullable(),
            city_id: Yup.string().nullable(),
            zip_code: Yup.string()
                .nullable()
                .matches(/^[0-9-]*$/, 'Invalid zip code format'),
        }),
        details: Yup.object().shape({
            website: Yup.string().nullable(),
        }),
    }),
    user: Yup.object().shape({
        name: Yup.string()
            .required('User name is required')
            .min(2, 'Name must be at least 2 characters'),
        surname: Yup.string()
            .required('User surname is required')
            .min(2, 'Surname must be at least 2 characters'),
        username: Yup.string()
            .required('Username is required')
            .min(4, 'Username must be at least 4 characters'),
        email: Yup.string()
            .email('Invalid email format')
            .required('User email is required'),
        phone: Yup.string()
            .required('User phone is required')
            .matches(/^[0-9+\-\s()]*$/, 'Invalid phone number format'),
        password: Yup.string()
            .required('Password is required')
            .min(8, 'Password must be at least 8 characters'),
    }),
}); 